module.exports = __webpack_public_path__ + "static/img/h_2_6.31e194a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/h_2_6.png
// module id = 4pNg
// module chunks = 0